import React, { useState, useEffect } from 'react'
import { useMediaQuery } from "@material-ui/core"
import { useTranslation } from "react-i18next"

import { ButtonHLPure, DialogSystemGLPure, InputHLPure, SimpleLoading, TextAreaHLPure } from '../../pures'
import "./configuration-domains-add.view.css"

const ConfigurationDomainsAddDomainView = (props) => {
    let {
        token,
        backGrid,
        loading,
        nameComponentUser,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        showLoadingRequesting,
        message,
        messageErrorCurrentDomain,
        errorCurrentDomain,
        createNewDomain,
        domainSelected,
        handleEditDomain
    } = props

    const { t } = useTranslation()

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [updatedByLabel, setUpdatedByLabel] = useState('')
    const [nameDisable, setNameDisable] = useState(false)

    useEffect(() => {
        if (nameComponentUser !== t("configurationPanelView.detail.domain.btn") || !domainSelected) return
        let modifiedBy = (domainSelected.updatedByUser) ? `${t("configurationDomainsAddDomainView.modify.by.2")} ${domainSelected.updatedByUser}` : ''
        let modifiedDate = (domainSelected.updatedDate) ? `${t("configurationDomainsAddDomainView.modify.by.3")} ${domainSelected.updatedDate}` : ''
        let labelUpdatedBy = `${t("configurationDomainsAddDomainView.modify.by.1")}  ${modifiedBy} ${modifiedDate}`
        let disableName = (domainSelected.signers) ? true : false
        setName(domainSelected.name)
        setDescription(domainSelected.description)
        setUpdatedByLabel(labelUpdatedBy)
        setNameDisable(disableName)
    }, [nameComponentUser, domainSelected])

    const handleChangeName = (e) => {
        setName(e.target.value)
    }

    const handleDescription = (e) => {
        setDescription(e.target.value)
    }

    const handleSubmit = () => {
        let data = {}
        data.name = name
        data.description = description
        if (nameComponentUser === t("configurationDomainView.newDomain")) {
            createNewDomain(data, backGrid)
        } else {
            data.id = domainSelected.id
            data.clientId = domainSelected.clientId
            handleEditDomain(data, backGrid)
        }
    }

    const isMobile = useMediaQuery("(max-width: 560px")

    return (
        <div className='configurationDomainsAddDomain-container'>
            {
                loading ? (
                    <SimpleLoading />
                ) : (
                    <div className='configurationDomainsAddDomain-body'>
                        {showLoadingRequesting ? (
                            <DialogSystemGLPure
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                showLoadingRequesting={showLoadingRequesting}
                            />
                        ) : null}
                        {showCompletedRequesting ? (
                            <DialogSystemGLPure
                                showCompletedRequesting={showCompletedRequesting}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                            />
                        ) : null}
                        {showErrorRequesting ? (
                            <DialogSystemGLPure
                                toggleErrorRequesting={toggleErrorRequesting}
                                message={message}
                                showErrorRequesting={showErrorRequesting}
                            />
                        ) : null}
                        <div className='configurationDomainsAddDomain-container-inputs'>
                            <div className='configurationDomainsAddDomain-input-name'>
                                <InputHLPure
                                    labelInput={t("configurationDomainsAddDomainView.name")}
                                    typeInput={"text"}
                                    valueInput={name}
                                    tooltipShow
                                    positionTooltip={isMobile ? "top" : "right"}
                                    titleTooltip={t("configurationDomainsAddDomainView.name")}
                                    descriptionTooltip={t("configurationDomainsAddDomainView.name.tooltip")}
                                    handleChangeInput={(e) => handleChangeName(e)}
                                    informationIcon={true}
                                    inputActive={true}
                                    errorInput={messageErrorCurrentDomain}
                                    errorInputText={errorCurrentDomain}
                                    disabled = {nameDisable ? true : false}
                                />
                            </div>
                            <div className='configurationDomainsAddDomain-description'>
                                <TextAreaHLPure
                                    labelTextArea={t("configurationDomainsAddDomainView.description")}
                                    valueTextData={description}
                                    positionTooltip={isMobile ? "top" : "right"}
                                    handleChangeTextArea={(e) => handleDescription(e)}
                                />
                            </div>
                        </div>
                        {
                            (nameComponentUser === t("configurationPanelView.detail.domain.btn")) ? (
                                <div className='configurationDomainsAddDomain-container-label-updatedBy'>
                                    <span>{updatedByLabel}</span>
                                </div>
                            ) : null
                        }
                        <div className='configurationDomainsAddDomain-container-btns'>
                            <div className='configurationDomainsAddDomain-btn-cancel'>
                                <ButtonHLPure
                                    nameBtn={t("button.cancel")}
                                    primary={false}
                                    onClickBtn={backGrid}
                                />
                            </div>

                            <ButtonHLPure
                                nameBtn={t("button.save")}
                                primary={true}
                                onClickBtn={() => handleSubmit()}
                            />
                        </div>
                    </div>

                )
            }
        </div>
    )
}

export default ConfigurationDomainsAddDomainView